/* File: src/pages/LogistMain/LogistMobile.jsx */
import React, { useState, useEffect } from "react";
import MapComponent from "../LogisistMainPage/components/LogistMapComponent";
import api from "../../../services/api";
import { useSocket } from "../../../context/SocketContext";
import { useGeolocationSubscription } from "../../../hooks/useGeolocationSubscription";
import "./LogistMobile.css";

export default function LogistMobile() {
  const [routes, setRoutes] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [showRoutesList, setShowRoutesList] = useState(false);
  const [showCouriers, setShowCouriers] = useState(false);
  const [courierLocations, setCourierLocations] = useState({});

  const socket = useSocket();

  // fetch routes
  useEffect(() => {
    api.get("/routes/by-date", { params: { startDate: new Date().toISOString().split("T")[0], endDate: new Date().toISOString().split("T")[0] } })
      .then(res => setRoutes(res || []))
      .catch(err => console.error(err));
  }, []);

  // geolocation subscription
  useGeolocationSubscription(false, showCouriers ? "trackAll" : null, null, (mode, enabled, reason) => {
    if (!enabled && reason) alert(`Гео (${mode}): ${reason}`);
  });

  // socket updates
  useEffect(() => {
    if (!socket) return;
    const handler = data => setCourierLocations(prev => ({ ...prev, [data.courierId]: data }));
    socket.on("courier:location:update", handler);
    return () => socket.off("courier:location:update", handler);
  }, [socket]);

  return (
    <div className="LM-container">
      {/* Full-screen map */}
      <MapComponent
        center={[55.751244, 37.618423]}
        zoom={12}
        receipts={selectedRoute ? selectedRoute.receipts : []}
        courierLocations={showCouriers ? Object.values(courierLocations) : []}
        highlightPosition={null}
      />

      {/* Bottom controls */}
      <div className="LM-bottom-bar">
        <button
          className="LM-btn"
          onClick={() => setShowCouriers(v => !v)}
        >
          {showCouriers ? "Скрыть курьеров" : "Показать курьеров"}
        </button>
        <button
          className="LM-btn"
          onClick={() => setShowRoutesList(true)}
        >
          Выбрать маршрут
        </button>
      </div>

      {/* Routes list overlay */}
      {showRoutesList && (
        <div className="LM-overlay" onClick={() => setShowRoutesList(false)}>
          <div className="LM-list" onClick={e => e.stopPropagation()}>
            <h3>Маршруты</h3>
            <ul>
              {routes.map(route => (
                <li
                  key={route.id}
                  className={route === selectedRoute ? 'active' : ''}
                  onClick={() => { setSelectedRoute(route); setShowRoutesList(false); }}
                >№{route.route_number} ({route.route_date})</li>
              ))}
            </ul>
            <button className="LM-close" onClick={() => setShowRoutesList(false)}>Закрыть</button>
          </div>
        </div>
      )}

      {/* Receipts modal */}
      {selectedRoute && (
        <div className="LM-overlay" onClick={() => setSelectedRoute(null)}>
          <div className="LM-modal" onClick={e => e.stopPropagation()}>
            <h3>Квитанции маршрута №{selectedRoute.route_number}</h3>
            <ul className="LM-receipts">
              {selectedRoute.receipts.map(r => (
                <li key={r.id}>
                  <span>#{r.receipt_number}</span>
                  <span>{r.client_name}</span>
                  <span className={`status status-${r.status.replace(/\s+/g,'')}`}>{r.status}</span>
                </li>
              ))}
            </ul>
            <button className="LM-close" onClick={() => setSelectedRoute(null)}>Закрыть</button>
          </div>
        </div>
      )}
    </div>
  );
}